import { notificationTypes } from './constants'
import { LOW_UPDATE_FREQUENCY_DAYS } from '../../../services/publishInfoRules'

/**
 * @param {Object} notification a normalized notification from the store
 * @param {Function} t the i18next translate function
 * @returns {{ title: string, body: string }}
 */
export const getNotificationContent = (notification, t) => {
  const payload = notification.payload ?? {}
  switch (notification.type) {
    case notificationTypes.CONTRADICTORY_FACTS:
      return {
        title: t('notificationCenter.types.contradictoryFacts.title', { count: payload?.pairs?.length ?? 0 }),
        body: t('notificationCenter.types.contradictoryFacts.body'),
      }
    case notificationTypes.PUBLISH_DELAY:
      return {
        title: t('notificationCenter.types.publishDelay.title'),
        body: t('notificationCenter.types.publishDelay.body'),
      }
    case notificationTypes.LOW_UPDATE_FREQUENCY:
      // the detail view renders the rich (bold) version of the body via <Trans>.
      return {
        title: t('notificationCenter.types.lowUpdateFrequency.title', { count: LOW_UPDATE_FREQUENCY_DAYS }),
        body: t('notificationCenter.types.lowUpdateFrequency.body'),
      }
    case notificationTypes.ROOMS_WITHOUT_IMAGES:
      return {
        title: t('notificationCenter.types.roomsWithoutImages.title'),
        body: t('notificationCenter.types.roomsWithoutImages.body', {
          count: payload.missing ?? 0,
          total: payload.total ?? 0,
        }),
      }
    case notificationTypes.LOW_RESOLUTION_IMAGES:
      return {
        title: t('notificationCenter.types.lowResolutionImages.title'),
        body: t('notificationCenter.types.lowResolutionImages.body', { count: payload.count ?? 0 }),
      }
    default:
      // generic/ad-hoc notifications carry their own copy in the payload.
      return {
        title: payload.title ?? '',
        body: payload.body ?? '',
      }
  }
}
